import React from 'react';
import { Link } from 'react-router-dom';

import styles from './RelatedArticles.module.scss';

const formatDate = (dateStr) => {
  if (!dateStr) {
    return '';
  }

  return new Date(dateStr).toLocaleDateString('ru-RU', {
    day: 'numeric',
    month: 'long',
    year: 'numeric',
  });
};

const RelatedArticles = ({ articles, title = 'Статьи по теме' }) => {
  if (!articles?.length) {
    return null;
  }

  return (
    <section className={styles.section}>
      <div className={styles.inner}>
        <h2 className={styles.title}>{title}</h2>
        <div className={styles.grid}>
          {articles.map((item) => (
            <article key={item.id} className={styles.card}>
              {item.cover_image && (
                <img
                  className={styles.cover}
                  src={item.cover_image}
                  alt={item.cover_image_alt || item.title}
                  loading="lazy"
                />
              )}
              <div className={styles.cardBody}>
                <h3 className={styles.cardTitle}>
                  <Link className={styles.cardLink} to={`/articles/${item.slug}`}>
                    {item.title}
                  </Link>
                </h3>
                {item.published_at && (
                  <p className={styles.date}>{formatDate(item.published_at)}</p>
                )}
                {item.short_description && (
                  <p className={styles.description}>{item.short_description}</p>
                )}
              </div>
            </article>
          ))}
        </div>
      </div>
    </section>
  );
};

export default RelatedArticles;
